import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ProfileStatusFieldEnum } from "@edp-enums/profile-status-field.enum";
import { ProfileStatus } from "@edp-models/profile-status.model";
import { EnvService } from "@edp-services/env.service";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { SelectOverlayAction } from "@edp-store/actions/layout.actions";
import { getProfileStatus } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";
import { DeviceDetectorService } from "ngx-device-detector";

const labelsDescription = {
    email: "pt.edp.edponline.complete.profile.description.email",
    phone: "pt.edp.edponline.complete.profile.description.phone",
};

const labelsButton = {
    email: "pt.edp.edponline.complete.profile.button.email",
    phone: "pt.edp.edponline.complete.profile.button.phone",
    default: "pt.edp.edponline.complete.profile.button",
};

@Component({
    selector: "edp-overlay-complete-profile",
    templateUrl: "./edp-overlay-complete-profile.component.html",
    styleUrls: ["./edp-overlay-complete-profile.component.scss"],
})
export class EdpOverlayCompleteProfileComponent implements OnInit {
    labelDescription: string | null;
    labelButton: string;
    profileStatus: ProfileStatus;
    field: ProfileStatusFieldEnum = null;
    public WIDGET_VALIDATE_EMAIL = "widget_validate_email";
    public WIDGET_VALIDATE_PHONE = "widget_validate_phone";
    public WIDGET_CLICK_NEXT = "widget_click_next";

    constructor(
        private readonly store: Store<IAppState>,
        private readonly router: Router,
        private readonly operationHistoryService: OperationHistoryService,
        private readonly envService: EnvService,
        private readonly deviceDetector: DeviceDetectorService,
    ) {}

    ngOnInit(): void {
        this.store.pipe(select(getProfileStatus)).subscribe((profileStatus: ProfileStatus) => {
            if (!!profileStatus) {
                this.profileStatus = profileStatus;
                if (!!this.profileStatus.incomplete[0]) {
                    this.field = this.profileStatus.incomplete[0];
                    this.setLabels();
                }
            }
        });
    }

    private setLabels(): void {
        this.labelDescription = labelsDescription[this.field] || null;
        this.labelButton = labelsButton[this.field] || labelsButton.default;
    }

    
    private redirectProfileIos(): void {
        window.location.href = `${this.envService.ssoUrl()}/profile?complete=${this.field}`;
    }
        
    public goToProfile(): void {
        this.store.dispatch(new SelectOverlayAction(null));
        this.fireOperationHistoryService();

        const isIOS =
            this.deviceDetector.device === "iPhone" ||
            this.deviceDetector.getDeviceInfo().os.toLowerCase() === "ios" ||
            navigator.platform.toLocaleLowerCase().includes("mac");

        if (isIOS) {
            this.redirectProfileIos();
            return;
        }
        this.router.navigate(["editar-perfil"], { queryParams: { complete: this.field } });
    }

    public fireOperationHistoryService() {
        const operation =
            this.field === ProfileStatusFieldEnum.email
                ? this.WIDGET_VALIDATE_EMAIL
                : this.field === ProfileStatusFieldEnum.phone
                ? this.WIDGET_VALIDATE_PHONE
                : this.WIDGET_CLICK_NEXT;
        return this.operationHistoryService.registerWithContract(null, operation);
    }
}
